import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowDownTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.872 7.17902L4.917 10.26L4.959 1.06602C4.95953 0.925333 4.98779 0.786134 5.04217 0.656385C5.09656 0.526636 5.17599 0.408885 5.27593 0.309872C5.37588 0.210858 5.49436 0.132525 5.62461 0.0793567C5.75487 0.026188 5.89432 -0.000772996 6.035 1.68656e-05C6.1756 0.00067166 6.3147 0.0290302 6.44433 0.0834714C6.57396 0.137913 6.6916 0.217369 6.7905 0.317298C6.88941 0.417228 6.96765 0.535671 7.02076 0.665856C7.07387 0.796042 7.10079 0.935418 7.1 1.07602L7.059 10.268L10.135 7.22802C10.2348 7.12893 10.3531 7.05048 10.4832 6.99715C10.6133 6.94383 10.7526 6.91666 10.8932 6.91722C11.0339 6.91778 11.173 6.94604 11.3027 7.0004C11.4323 7.05476 11.55 7.13414 11.649 7.23402C11.8488 7.43594 11.9603 7.70891 11.959 7.99297C11.9577 8.27702 11.8437 8.54895 11.642 8.74902L6.593 13.749C6.42724 13.9129 6.20316 14.0042 5.97006 14.0029C5.73695 14.0016 5.51392 13.9078 5.35 13.742L0.350005 8.68902C0.15027 8.48726 0.0388107 8.21446 0.040123 7.93057C0.0414352 7.64667 0.155413 7.37491 0.357005 7.17502C0.456726 7.07577 0.575025 6.99714 0.705141 6.94363C0.835258 6.89012 0.974643 6.86277 1.11533 6.86314C1.25602 6.86351 1.39526 6.8916 1.5251 6.9458C1.65493 7 1.77281 7.07925 1.872 7.17902Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ArrowDownTwoSVG;
